// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export const FeedbackOptions = [
    'This message is too short or incomplete',
    'This message is incorrect',
    'This message is too detailed or has unnecessary information'
];